import { createContext } from 'preact';

export type LayerLevel = 'nearestAncestor' | 'topLevel';
export type LayerPriority = 'popup' | 'dialog' | 'messages' | 'tooltip';

export type LayerContextProps = {
  getRootLayerHost?: (priority?: LayerPriority) => Element;
  getLayerHost?: (priority?: LayerPriority) => Element;
  onLayerUnmount?: (element: HTMLElement) => void;
};

export const LayerContext = createContext<LayerContextProps>({});
